import Axios from 'axios'

import {
  TCommentApi,
  CreateCommentBody,
  UpdateCommentBody
} from 'types/GlobalComment'

import { getWithRedirect } from 'utils/axios'
import { parseAuthenticationHeader } from 'helpers/Functions'

const BASE_URL =
  process.env.NODE_ENV === 'development'
    ? 'http://localhost:3990/'
    : process.env.REACT_APP_HOMEPAL_MDM_API_PROD

const URL = `${BASE_URL}v1/comments`

export async function getAll(keyMetricId: string) {
  return getWithRedirect<TCommentApi[]>(`${URL}?key_metric_id=${keyMetricId}`)
}

export async function getAllByReportEdition(reportEditionId: string) {
  return getWithRedirect<TCommentApi[]>(
    `${URL}?report_edition_id=${reportEditionId}`
  )
}

export async function getAllByAnalysis(analysisId: string) {
  return getWithRedirect<TCommentApi[]>(`${URL}?analysis_id=${analysisId}`)
}

export async function create(body: CreateCommentBody) {
  return Axios.post<{ data: TCommentApi }>(
    URL,
    { data: body },
    parseAuthenticationHeader()
  )
}

export async function update(id: string, body: UpdateCommentBody) {
  return Axios.patch<{ data: TCommentApi }>(
    `${URL}/${id}`,
    { data: body },
    parseAuthenticationHeader()
  )
}

export async function destroy(id: string) {
  return Axios.delete(`${URL}/${id}`, parseAuthenticationHeader())
}
